<p class="label" i18n>Select shape</p>
<tm-map-drawing-buttons [drawingLayerId]="drawingLayerId"
                        [selectionStyle]="selectionStyle"
                        (drawingAdded)="onDrawingAdded($event)"
                        (activeToolChanged)="onActiveToolChanged($event)"
                        (featureSelected)="onFeatureSelected($event)"></tm-map-drawing-buttons>
